module.exports = __webpack_public_path__ + "media/images/icons/outgoing-9024cc9a6d1959b1e671446ca4ecee7e.png";